import { generalMessage } from "../utils/ErrorMessages";

export default {
  methods: {
    ceilDecimals(decimal) {
      return Math.ceil(decimal);
    },
    async getHazmatInformation() {
      const completeDataDetails = await this.$store.dispatch("load/getLoadByIdLoadDetailsView", this.$route.params.loadId);
      const existingHazmatContact = completeDataDetails.line_items.find(
        (item) => item.hazardous_materials && item.hazmat_contact
      )?.hazmat_contact;
      this.hazmatInformation = this.completeData.map((item, index) => {
        const hazmat = {
          hazmat_class_division: item.hazmat_class_division,
          hazmat_number_type: item.hazmat_number_type,
          hazmat_packaging_group: item.hazmat_packaging_group,
          hazmat_number: item.hazmat_number,
          hazmat_contact: completeDataDetails.line_items[index]?.hazmat_contact
            || existingHazmatContact
            || process.env.VUE_APP_HAZMAT_ID_DEV,
          hazardous_materials: true,
        };
        const lineItemId = item.line_item_id;
        return { hazmat, lineItemId };
      });
    },
    searchItemsWithHazmat(data) {
      if (data) {
        this.lineItems = [...data];
      }
      this.isAnyItemWithHazmat = this.lineItems.some((item) => item.hazardous_materials);
      return this.isAnyItemWithHazmat;
    },
    showHazmatError(payload) {
      this.hazmatError = payload;
    },
    isRequiredHazmat(data) {
      this.$emit("validateHazmatInformation", data);
    },
    findDefaultHazmatItem() {
      const lineItems = this.$store.getters["load/getChosenLoad"].line_items;
      const defaulHazmatItem = lineItems.find((item) => {
        let foundItem = null;
        if (item.hazardous_materials && !this.checkIfHazmatInfoWasFilled(item)) {
          foundItem = item;
        }
        return foundItem;
      });
      if (defaulHazmatItem) {
        const payload = {
          id: this.$route.params.loadId,
          lineItemId: defaulHazmatItem.line_item_id,
          body: {
            hazardous_materials: false,
          },
        };
        return this.$store.dispatch("load/lineItems/updatedLineItem", payload);
      }
      return null;
    },
    checkIfHazmatInfoWasFilled(item) {
      const hazmatVariables = [
        "hazmat_class_division",
        "hazmat_number_type",
        "hazmat_packaging_group",
        "hazmat_number",
      ];
      let hazmatInfoFilled = true;
      hazmatVariables.forEach((variable) => {
        if (!item[variable]) {
          hazmatInfoFilled = false;
        }
      });
      return hazmatInfoFilled;
    },
    updateVuexLineItems(data, index, selectedLineItems) {
      const lineItemsCopy = JSON.parse(JSON.stringify(selectedLineItems));
      lineItemsCopy[index] = { ...lineItemsCopy[index], ...data };
      this.$store.commit("load/modifyChosenLoadSpecificData", {
        key: "line_items",
        value: lineItemsCopy,
      });
    },
    async dispatchLineItemUpdate(payload, applyToAll = false) {
      if (!this.$options.filters.checkPermission("patch:line-item")) {
        return;
      }
      await this.$store.dispatch("load/lineItems/updatedLineItem", payload);
      if (applyToAll) {
        const completeDataDetails = await this.$store.dispatch("load/getLoadByIdLoadDetailsView", this.$route.params.loadId);
        const params = {
          id: payload.id,
          body: {
            line_items: completeDataDetails.line_items
              .filter((item) => item.hazardous_materials && item.line_item_id !== payload.lineItemId)
              .map((item) => ({
                id: item.id,
                hazmat_contact: payload.body.hazmat_contact,
                hazardous_materials: true,
              })),
          },
        };
        if (params.body.line_items.length > 0) {
          await this.$store.dispatch("load/lineItems/updateMultipleLineItems", params);
        }
      }
    },
    async updateHazmatInformation(data, index, applyToAll) {
      this.$store.commit("load/tender/setRequestInProcess", true);
      const payload = {
        id: this.$route.params.loadId,
        lineItemId: this.lineItems[index].line_item_id,
        body: {
          hazardous_materials: this.lineItems[index].hazardous_materials,
        },
      };
      Object.keys(data).forEach((key) => {
        payload.body[key] = data[key];
      });
      payload.body.hazmat_contact = payload.body?.hazmat_contact?.id
        || payload.body?.hazmat_contact
        || this.lineItems[index].hazmat_contact;
      await this.dispatchLineItemUpdate(payload, !!applyToAll);
      if (applyToAll) {
        this.applyHazmatContactLocally(payload.body.hazmat_contact);
      }
      if (applyToAll === true) {
        generalMessage("Hazmat labeling applied to all items");
      } else if (applyToAll === false) {
        generalMessage("Hazmat information has been properly recorded.");
      }
      this.$store.commit("load/tender/setRequestInProcess", false);
    },
    applyHazmatContactLocally(hazmatContact) {
      const lineItems = this.$store.getters["load/getChosenLoad"].line_items;
      const updatedLineItems = lineItems.map((item) => (
        item.hazardous_materials
          ? { ...item, hazmat_contact: hazmatContact }
          : item
      ));
      this.$store.commit("load/modifyChosenLoadSpecificData", {
        key: "line_items",
        value: updatedLineItems,
      });
    },
    findItemWithHazmatInfo(isHazmat) {
      if (typeof isHazmat === "undefined" && !isHazmat) {
        return false;
      }
      const hazmatVariables = [
        "hazmat_class_division",
        "hazmat_number_type",
        "hazmat_packaging_group",
        "hazmat_number",
      ];
      let infoWasFilled = false;
      for (let i = 0; i < this.data.length; i += 1) {
        for (let j = 0; j < hazmatVariables.length; j += 1) {
          if (this.data[i][hazmatVariables[j]]) {
            infoWasFilled = true;
            break;
          }
        }
        if (infoWasFilled) {
          break;
        }
      }
      this.isAnyItemWithHazmat = infoWasFilled;
      return infoWasFilled;
    },
    validatePackagingCountAndUnits(index) {
      if (this.isAnyItemWithHazmat && (!this.lineItems[index].packaging_unit_count && !this.lineItems[index].packaging_units)) {
        return true;
      }
      return false;
    },
    validateIfNmfcFieldwasFilled() {
      let itemNumber;
      let infoWasFilled = true;
      for (let i = 0; i < this.data.length; i += 1) {
        if (this.data[i].nmfcFieldEnabled && !this.data[i].nmfc_number) {
          infoWasFilled = false;
          itemNumber = i + 1;
          break;
        }
      }
      return { infoWasFilled, itemNumber };
    },
  }
};
